import { useState } from "react";
import { Link } from "react-router-dom";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      setStatus("error");
      setMessage("Please enter a valid email address.");
      return;
    }

    setStatus("loading");
    setMessage("");

    try {
      // Chiamata diretta al backend di Render per l'iscrizione alla newsletter
      const response = await fetch("https://alkeon-backend.onrender.com/api/newsletter", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setStatus("success");
        if (data.status === "already_subscribed") {
          setMessage("You are already subscribed.");
        } else {
          setMessage("Thank you for joining the atelier.");
          setEmail("");
        }
      } else {
        setStatus("error");
        setMessage("An error occurred. Please try again.");
      }
    } catch (err) {
      console.error("Newsletter error:", err);
      setStatus("error");
      setMessage("Unable to connect. Please try again later.");
    }
  };

  return (
    <footer className="bg-ink text-bone pt-20 pb-10 px-5 md:px-14 lg:px-20 border-t border-bone/10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-bone/10">
        
        {/* Newsletter & Brand Intro */}
        <div className="md:col-span-6 space-y-6">
          <p className="label">Letters from the Atelier</p>
          <h3 className="font-serif text-3xl md:text-4xl font-light italic text-bone">
            New forms, announced quietly.
          </h3>
          <form className="flex flex-col gap-2 max-w-md pt-4" onSubmit={handleSubscribe}>
            <div className="flex gap-4 w-full">
              <input 
                type="email" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address" 
                disabled={status === "loading"}
                className="bg-transparent border-b border-stone/40 py-2 text-sm text-bone placeholder:text-stone focus:outline-none focus:border-bone w-full transition-colors"
              />
              <button 
                type="submit" 
                disabled={status === "loading"}
                className="text-stone hover:text-bone transition-colors text-sm uppercase tracking-widest cursor-pointer"
              >
                {status === "loading" ? "..." : "→"}
              </button>
            </div>
            
            {message && (
              <p className={`text-xs tracking-wide font-light mt-1 ${
                status === "error" ? "text-red-400" : "text-[#c5b358]"
              }`}>
                {message}
              </p>
            )}
          </form>
        </div>

        {/* Navigation Links */}
        <div className="md:col-span-6 grid grid-cols-2 gap-8 text-right md:justify-items-end">
          <div className="space-y-3">
            <p className="text-[10px] uppercase tracking-[0.25em] text-stone mb-4 font-medium">Navigation:</p>
            <p><a href="#collection" className="nav-link text-sm">Collection</a></p>
            <p><a href="#philosophy" className="nav-link text-sm">Philosophy</a></p>
            <p><a href="#atelier" className="nav-link text-sm">Atelier</a></p>
          </div>
          <div className="space-y-3">
            <p className="text-[10px] uppercase tracking-[0.25em] text-stone mb-4 font-medium">Social:</p>
            <p>
              <a 
                href="https://www.instagram.com/alkeontimelessdesign/" 
                target="_blank" 
                rel="noreferrer" 
                className="nav-link text-sm"
              >
                Instagram
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-stone font-light tracking-widest">
        <div className="flex items-center gap-3">
          <img src="alkeon-logo.jpg" alt="ALKEON Logo" className="h-8 w-auto rounded-sm opacity-80" />
        </div>
        
        <div className="flex flex-wrap items-center justify-center md:justify-end gap-x-4 gap-y-2 uppercase text-[11px]">
          <span>© 2026 ALKEON | Timeless Design</span>
          <span>·</span>
          <Link to="/terms-and-returns" className="hover:text-bone transition-colors">Terms & Returns</Link>
          <span>·</span>
          <Link to="/legal-imprint" className="hover:text-bone transition-colors">Legal Imprint</Link>
          <span>·</span>
          <Link to="/privacy-policy" className="hover:text-bone transition-colors">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;